<template>
  <div class="event-outer-box">
    <div class="event-operate">
      <div class="event-btn" @click="changeBriefLayer(true)">
        <span>
          考核要求与进度
        </span>

      </div>
    </div>
    <div :class="[
        'operate-layer-box',
        showLayer ? 'show-layer' : 'hide-layer',
      ]">
      <div class="layer-header">
        <div class="layer-label">
          考核要求与进度
        </div>
        <div class="layer-close" @click="changeBriefLayer(false)"></div>
        <div class="layer-close-left" @click="changeBriefLayer(false)"></div>
      </div>
      <div class="layer-content">
        <div class="event-item" v-for="item,index in taskData" :key="index">
          <div class="event-name">{{ item.name }}</div>
          <div class="event-child">
            <div class="child-item" v-for="childItem,childIndex in item.children" :key="childIndex">
              <div class="child-header" @click="handleClick(childItem)">
                <div class="child-name">
                  {{ childItem.name }}
                </div>
                <div class="child-progress-wrapper">
                  <div class="child-progress">
                    <div class="progress-inner" :style="{width:`${(childItem.num/childItem.total_num) * 100}%`}"></div>
                  </div>
                  <div class="progress-num">
                    {{ childItem.num }} / {{ childItem.total_num }}
                  </div>
                </div>
              </div>
              <div class="child-score">
                <div class="score-item">
                  <img src="../../assets/image/student/common/layer-fullscore.png">
                  满分 · {{ childItem.total_score }}
                </div>
                <div :class="['score-item',childItem.is_score == 2?'light':'']">
                  <img src="../../assets/image/student/common/layer-userscore.png">
                  得分 · <span>{{ childItem.is_score == 2 ?'待评':childItem.score }}</span>
                </div>
              </div>
              <div class="child-intro">
                {{ childItem.requirement }}
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: "EventAside",
  data () {
    return {
      showLayer: true, // 默认展开
      school_code: localStorage.getItem("schoolCode"),
    };
  },
  computed: {
    ...mapState({
      taskData: (state) => state.train.taskData
    }),
  },
  mounted () {
    let isOpen = localStorage.getItem("menuOpen")
    this.changeBriefLayer(isOpen == "1" ? true : false)
  },
  watch: {
    showLayer (newVal) {
      localStorage.setItem("menuOpen", newVal ? "1" : "2") // 1开启 2关闭
    },
  },
  methods: {
    // layer 显示/隐藏
    changeBriefLayer (val) {
      this.showLayer = val;
    },
    // 任务点击
    handleClick (taskItem) {
      let router = this.$router.options.routes.filter(item => item.path.indexOf("/student/experiment") > -1)[0].children
      let path = "/" + this.school_code + "/student/experiment/" + router.filter(item => item.code == taskItem.code)[0].path
      this.$router.replace({ path, query: { ...this.$route.query } }).catch(err => { err })
    },
  },
};
</script>

<style lang="less" scoped>
.event-outer-box {
    .event-operate {
        position: fixed;
        top: 50%;
        right: 0;
        z-index: 99;
        transform: translateY(-50%);
        .event-btn {
            width: 36px;
            height: 155px;
            background: linear-gradient(90deg, #c0403a 3%, #bb1c15 100%);
            border-radius: 4px 0px 0px 4px;
            cursor: pointer;
            span {
                display: inline-block;
                letter-spacing: 1px;
                margin: 3px 7px 0;
                writing-mode: vertical-lr;
                font-weight: bold;
                font-size: 14px;
                color: #ffeab3;
            }
            &::before {
                content: '';
                display: inline-block;
                width: 15px;
                height: 15px;
                background-size: 100% auto;
                margin: 13px 10px 0;
                background: url('../../assets/image/student/common/layer-show.png')
                    no-repeat center/cover;
            }
        }
    }
    .operate-layer-box {
        position: fixed;
        top: 128px;
        bottom: 0;
        right: 0;
        z-index: 100;
        width: 280px;
        background: #ffffff;
        box-shadow: 0px 4px 10px 0px rgba(119, 124, 127, 0.18);
        border: 1px solid #e7eaec;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        transition: right 0.3s;
        &.show-layer {
            width: 280px;
            right: 0;
        }
        &.hide-layer {
            width: 0;
            right: -50px;
        }
        .layer-header {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 36px;
            background: linear-gradient(90deg, #bb1d15 0%, #a82822 100%);
            padding: 0 12px;
            .layer-label {
                font-weight: bold;
                font-size: 14px;
                color: #ffeab3;
                &::before {
                    content: '';
                    display: inline-block;
                    width: 15px;
                    height: 17px;
                    margin-right: 3px;
                    background: url('../../assets/image/student/common/layer-label.png')
                        no-repeat center/cover;
                    vertical-align: -3px;
                }
            }
            .layer-close {
                cursor: pointer;
                width: 12px;
                height: 13px;
                background: url('../../assets/image/student/common/layer-close.png')
                    no-repeat center/cover;
            }
            .layer-close-left {
                width: 22px;
                height: 28px;
                background: url('../../assets/image/student/common/layer-close-2.png')
                    no-repeat center/cover;
                position: absolute;
                left: -21px;
                z-index: -1;
                top: 42px;
                cursor: pointer;
            }
        }
        .layer-content {
            flex: 1;
            overflow-y: auto;
            background: #fff;
            padding: 6px 0 10px;
            .event-item {
                &:not(:first-child) {
                    margin-top: 18px;
                }
                .event-name {
                    width: 100%;
                    height: 28px;
                    background: #fff1e9;
                    line-height: 28px;
                    padding: 0 14px;
                    font-weight: bold;
                    font-size: 14px;
                    color: #a82822;
                }
                .event-child {
                    .child-item {
                        .child-header {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding: 11px 14px 5px;
                            cursor: pointer;
                            .child-name {
                                font-size: 14px;
                                color: #2f2626;
                            }
                            .child-progress-wrapper {
                                display: flex;
                                align-items: center;
                                .child-progress {
                                    margin: 0 7px 0 auto;
                                    width: 40px;
                                    height: 4px;
                                    background: #e8ebed;
                                    border-radius: 2px;
                                    overflow: hidden;
                                    .progress-inner {
                                        height: 4px;
                                        background: linear-gradient(
                                            90deg,
                                            #e15c56 0%,
                                            #a82822 100%
                                        );
                                        border-radius: 2px;
                                    }
                                }
                                .progress-num {
                                    font-size: 12px;
                                    color: #a3a6aa;
                                }
                            }
                        }
                        .child-score {
                            display: flex;
                            align-items: center;
                            padding: 0 14px 8px;
                            .score-item {
                                font-size: 14px;
                                color: #8f9193;
                                img {
                                    height: 12px;
                                    width: auto;
                                    margin-right: 2px;
                                    vertical-align: -1px;
                                }
                                &:not(:last-child) {
                                    margin-right: 30px;
                                }
                                &.light span {
                                    font-weight: bold;
                                    color: #7b5127;
                                }
                            }
                        }
                        .child-intro {
                            width: 100%;
                            background: rgba(248, 248, 248, 0.4);
                            font-size: 12px;
                            color: #969ca3;
                            line-height: 17px;
                            padding: 7px 14px;
                        }
                    }
                }
            }
        }
    }
}
</style>